import React from 'react';

import { useGraphQLSuspenseQuery } from '@betterment/graphql';
import { NotFound } from '@betterment/shared-components/src/components/not-found/NotFound';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { HouseholdCta } from './HouseholdCta';
import { HouseholdDocument } from './HouseholdSummary/graphql/query.household.generated';

import urlBuilder from '../../Shared/url-builder';
import { Header as BettermentHeader } from '../BettermentForAdvisors/Header';

export const Header: React.FC = () => {
  const householdId = useRequiredParam('householdId');
  const { data } = useGraphQLSuspenseQuery(HouseholdDocument, { variables: { id: householdId } });

  const { household } = data;

  if (household.__typename === 'RecordNotFoundResult') {
    return <NotFound backPath={urlBuilder.getHouseholdsListPage.absolute()} backName="the clients page" />;
  }

  const HOUSEHOLD_NAV: {
    label: string;
    to: string;
    isExact: boolean;
    shouldReloadDocument?: boolean;
  }[] = [
    {
      label: 'Overview',
      to: urlBuilder.getHouseholdSummaryPage.absolute({ householdId }),
      isExact: true,
    },
    {
      label: 'Activity',
      to: urlBuilder.getHouseholdsActivityPage.absolute({ householdId }),
      isExact: true,
    },
    {
      label: 'Household',
      to: urlBuilder.getHouseholdsMembersPage.absolute({ householdId }),
      isExact: true,
    },
    {
      label: 'Taxes',
      to: urlBuilder.getHouseholdsTaxFormsPage.absolute({ householdId }),
      isExact: true,
    },
    {
      label: 'Settings',
      to: urlBuilder.getHouseholdsSettingsPage.absolute({ householdId }),
      isExact: true,
    },
  ];

  return (
    <BettermentHeader
      title={household.name}
      navigation={HOUSEHOLD_NAV}
      cta={
        <HouseholdCta
          members={household.members}
          showImpersonationModal={false}
          accountCreationAllowed={data.firm.accountCreationAllowed}
        />
      }
      backLink={{
        to: urlBuilder.getHouseholdsListPage.absolute(),
        title: 'All clients',
        shouldReloadDocument: true,
      }}
    />
  );
};
